import { IApplicationKey } from "../pages/auth/AuthContext/ApplicationContext";

export const getApiUrl = (app: IApplicationKey | null) => app ?
  `${process.env.REACT_APP_GATEWAY_URL}/${app}` :
  process.env.REACT_APP_GATEWAY_URL;
